import { useQuery } from '@tanstack/react-query';
import { deliveryReportQueries } from '../api/delivery-report-queries';

/** The delivery reports payload (all three report tabs). */
export function useDeliveryReport() {
  return useQuery(deliveryReportQueries.summary());
}
